import {Alert, Button, Modal, ModalBody} from "react-bootstrap";
import React, {useCallback, useContext, useEffect, useState} from "react";
import Logout from "../menu/Logout";
import authContext from "../../store/auth-context";
import useCallBackend from "../../hooks/use-call-backend";
import Loading from "../loading";
import Error from "../error";
import {TokenRefreshResponse} from "../../modal/token-refresh-response";
import {useNavigate} from "react-router-dom";
import Countdown from "../countdown";

const LogoutWarning:React.FC = () => {
    let navigate = useNavigate();
    const authCtx = useContext(authContext);
    const [showWarning, setShowWarning] = useState(false);
    const [remainingTime, setRemainingTime] = useState(0);
    const {isLoading, error, invokeBackend} = useCallBackend();
    const [refreshError, setRefreshError] = useState<string | null>(null);

    useEffect(() => {
        let showWarningTimer: NodeJS.Timeout | null = null;
        if(authCtx.sessionTime < 300000){
            setRemainingTime(Math.floor(authCtx.sessionTime !== 0 ? authCtx.sessionTime / 1000 : 0))
            setShowWarning(true);
        } else {
            showWarningTimer = setTimeout(() => {
                setRemainingTime(300);
                setShowWarning(true);
            }, authCtx.sessionTime - 300000);
        }
        return () => {
            if(showWarningTimer !== null){
                clearTimeout(showWarningTimer);
            }
        }
    }, [authCtx]);

    const handleResponse = (response: TokenRefreshResponse) => {
        if(!response.successful){
            setRefreshError(response.message);
        }else if(response.token !== null && response.expiresIn !== null){
            const expiresInMilliseconds = new Date().getTime() + (response.expiresIn * 1000);
            const expirationTime = new Date(expiresInMilliseconds);
            authCtx.refresh(response.token, expirationTime.toISOString());
            setShowWarning(false);
        }
    }

    const handleContinue = () => {
        setRefreshError(null); //reset
        invokeBackend({url: "/api/refresh/token"}, handleResponse);
    }

    const handleLogout = useCallback( () => {
        authCtx.logout();
        navigate("/");
    }, [authCtx, navigate])

    const actionButtons = (<div>
        <Button variant="primary" type="button" onClick={handleContinue}>Continue</Button><Logout />
    </div>);

    return (<Modal show={showWarning}>
        <ModalBody className="p-0">
            {error && <Error message={error} />}
            {refreshError && <Error message={refreshError} />}
            <Alert variant="danger" className="m-0">
                <strong>Warning!</strong><br/>
                You session is about to expire in <Countdown time={remainingTime} logoutHandler={handleLogout} />.<br/>
                {!isLoading && actionButtons}
                {isLoading && <Loading />}
            </Alert>
        </ModalBody>
    </Modal>);
}

export default LogoutWarning;